var ezdia;
(function (ezdia) {
    var pageParams = {};
    var contentBody = '#ez-profile-container-body';
    var actiontype = 'edit_profile';
    var requestedRoleMultichoice = function () {
        $('#requested_role-multichoice').on('change', function () {
            var value = $('#requested_role-multichoice').val();
            $('#requested_role').val(value != null ? value.join('##') : '');
            var reqRoles = ['Common'];
            $.each($('#requested_role').val().split('##'), function (i, val) {
                reqRoles.push(val);
            });
            showHideEditProfileFields(reqRoles);
        });
    };
    var profilePictureDialog = function (data) {
        $('#responsediv').html(data);
        $('#responsediv').dialog({
            modal: true,
            width: 550,
            height: 'auto',
            title: 'Update Profile Picture',
            buttons: [
                {
                    text: 'Cancel',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Update Picture',
                    click: function () {
                        updateImage($(this));
                    }
                }
            ]
        });
    };
    var profilePicture = function () {
        $('#editProfilePic').click(function () {
            $.ajax({
                type: 'POST',
                url: 'profilepic.htm',
                dataType: 'text',
                success: function (data) {
                    profilePictureDialog(data);
                },
                error: function (data) {
                    profilePictureDialog(data);
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var getRequiredObject = function () {
        $.each(pageParams.colModel, function (i, column) {
            if (column.config) {
                $.ezdia.validate.init(pageParams.required, column);
            }
        });
    };
    function handelUpdateSuccess(data) {
        var wrapper = $.ezdia.getWrapper('ez-js-update-profile-psswd-wrapper');
        wrapper.html(data.msg);
        var buttonTitle;
        var buttonRedirectUrl;
        if ($.ezdia.config.pageParams.isHome === 'true') {
            buttonTitle = 'Go To Dashboard';
            buttonRedirectUrl = 'getGlobalDashboardData.htm';
        }
        else {
            buttonTitle = 'Go To my Profile';
            buttonRedirectUrl = 'Settings.htm';
        }
        wrapper.dialog({
            closeOnEscape: false,
            open: function (e, ui) {
                // tslint:disable-next-line:no-bitwise
                $('.ui-dialog-title', ui.dialog || ui).css({
                    width: '100%'
                });
                $('.ui-dialog-titlebar-close', ui.dialog || ui).hide();
            },
            modal: true,
            title: 'Success',
            width: 450,
            height: 175,
            buttons: [
                {
                    text: buttonTitle,
                    class: 'btn-primary',
                    click: function () {
                        window.location.href = buttonRedirectUrl;
                    }
                }
            ]
        });
    }
    function handelUpdateError(data) {
        // eslint-disable-next-line no-alert
        ezdia.alert('Error', data);
    }
    function handelUpdateAjax() {
        var frm = $('#updateprofile');
        if (!frm.valid()) {
            return;
        }
        $.ezdia.loading.show();
        var data = frm.serializeArray();
        data.push({
            name: 'password',
            value: $('#ez-js-profile-psswd-input').val()
        });
        $.ajax({
            type: 'POST',
            url: 'UpdateProfile.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                $.ezdia.loading.hide();
                if (response.success) {
                    handelUpdateSuccess(response);
                }
                else {
                    handelUpdateError(response.msg);
                }
            },
            error: function (error) {
                $.ezdia.loading.hide();
                // eslint-disable-next-line no-console
                console.log("UpdateProfile error " + error);
            }
        });
    }
    function handelCountryChange() {
        var payment = $('#payment_mode');
        var neft = payment.find('[value="NEFT"]').hide();
        $('#country')
            .on('change', function change() {
            if (this.value === 'India') {
                neft.show();
            }
            else {
                neft.hide();
                payment.val('');
                toggleBankDetails();
            }
            payment.trigger('chosen:updated');
        })
            .trigger('change');
    }
    function handelPaymentModeChange() {
        $('#payment_mode')
            .on('change', function change() {
            if (this.value === 'NEFT') {
                toggleBankDetails(true);
            }
            else {
                toggleBankDetails();
            }
        })
            .trigger('change');
    }
    function toggleBankDetails(show) {
        var bankDetailsW = $('#bank_acc_holder_name-main,#bank_branch_name-main,#bank_ifsc_code-main,#bank_account_no-main,#pan-main');
        var bankDetails = $('#bank_acc_holder_name,#bank_branch_name,#bank_ifsc_code,#bank_account_no,#pan');
        if (show) {
            bankDetailsW.show();
            bankDetails.removeAttr('disabled');
        }
        else {
            bankDetailsW.hide();
            bankDetails.attr('disabled', 'disabled');
        }
    }
    var profileObj = {
        load: {
            view: function () {
                pageParams = $.ezdia.config.pageParams;
                var colModel = pageParams.colModel;
                var context = $.extend(true, {}, pageParams.colModel);
                var template = $.ezdia.template.get('profile-view');
                var city = context.city ? context.city.value + ", " : '';
                var state = context.state ? context.state.value + ", " : '';
                var country = context.country ? context.country.value : '';
                var location = city + state + country;
                context.location = {
                    column: {
                        name: 'location'
                    },
                    value: location
                };
                if (colModel.resume && colModel.resume.value) {
                    var resume = $.ezdia.getJsonObject(colModel.resume.value);
                    if (resume) {
                        context.resume = {
                            column: colModel.resume.column,
                            value: resume[0].thumbnailUrl
                        };
                    }
                }
                var content = template(context);
                $(contentBody).html(content);
                pageLoadingDone();
            },
            edit: function () {
                pageParams = $.ezdia.config.pageParams;
                var fieldvalues = pageParams.formFieldValues;
                var colModel = $.extend(true, {}, pageParams.colModel);
                var content = '';
                $.each(colModel, function (i, col) {
                    col.id = col.id || col.name;
                    var row = $.ezdia.inputs.getMarkup({
                        column: col,
                        value: fieldvalues[col.name] || ''
                    }, actiontype);
                    content += row.prop('outerHTML');
                });
                $('#updateprofilefields').replaceWith(content);
                $('[name="email"]').attr('readonly', 'readonly');
                $.ezdia.validate.all(pageParams.colModel, 'updateprofile');
                $.ezdia.widgets.renderAll(pageParams.colModel, actiontype);
                if (pageParams.reqRoles) {
                    showHideEditProfileFields(ezdia.util.jsonParse(pageParams.reqRoles));
                }
                $('#updateProfileBtn').on('click', handelUpdateAjax);
                requestedRoleMultichoice();
                profilePicture();
                toggleBankDetails();
                handelCountryChange();
                handelPaymentModeChange();
                pageLoadingDone();
            }
        }
    };
    var pages;
    (function (pages) {
        pages.profile = profileObj;
    })(pages = ezdia.pages || (ezdia.pages = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.profile = profileObj;
})(ezdia || (ezdia = {}));
